import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing['4']}px;
`;

export const ProdutoInfoTextos = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing['2']}px;
`;

export const ProdutoTags = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  gap: ${({ theme }) => theme.spacing['2']}px;
`;

export const ProdutoImagem = styled.div`
  position: relative;
  height: 168px;
`;
